import { createReducer } from "@reduxjs/toolkit";
const initialState = {
    isLoading: false,
  };

  const videoCategorysReducer = createReducer(initialState, (builder) => {
    builder
      .addCase("get_all_videoCategorys_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_all_videoCategorys_success", (state,action) => {
        state.isLoading = false;
        state.videoCategorys = action.payload.videoCategorys;
        state.pagination = action.payload.pagination;
      })
      .addCase("get_all_videoCategorys_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_Fillter_videoCategorys_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_Fillter_videoCategorys_success", (state,action) => {
        state.isLoading = false;
        state.FilterVideoCategorys = action.payload.videoCategorys;
        state.pagination = action.payload.pagination;
      })
      .addCase("get_Fillter_videoCategorys_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_videoCategory_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_videoCategory_success", (state,action) => {
        state.isLoading = false;
        state.videoCategoryData = action.payload;
      })
      .addCase("get_videoCategory_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      });
  });
  
  export default videoCategorysReducer;